module.exports = __webpack_public_path__ + "static/img/footOneImg2.e63241e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footOneImg2.png
// module id = Ytou
// module chunks = 1